import React from 'react'

import { Flex } from '@guiker/react-framework'
import { ProjectWithDeveloper } from '@guiker/real-estate-shared'

import { Document } from '../Document'

type ProjectDocumentsProps = {
  project: ProjectWithDeveloper
}

const ProjectDocuments: React.FC<ProjectDocumentsProps> = ({ project }) => {
  const developerDocuments = [...(project?.documents || []), ...(project?.developer?.documents || [])]

  return (
    <>
      {!!developerDocuments.length && developerDocuments.length > 0 && (
        <Flex flexDirection='column' gap={3}>
          {developerDocuments.map((document) => (
            <Document key={document.id} url={document.url} displayName={document.displayName ?? document.fileName} />
          ))}
        </Flex>
      )}
    </>
  )
}

export { ProjectDocuments }
